//identify.js
import request from '@/utils/request';

export function getCaptcha(params) {
  return request({
    url: '/v1/captcha/render',
    method: 'get',
    params: params,
    withCredentials: true,
    responseType: 'blob',
  });
}
